import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'concourse-avatar',
  styleUrl: 'councourse-avatar.css',
})

/**
 * Component to show the avatar of a user.
 * Show image if available, else show initials, else show default icon.
 */
export class ConcourseAvatar {
  @Prop() initials: string;
  @Prop() imageUrl: string;
  @Prop() color: string;
  @Prop() border: boolean = true;
  @Prop() size: 'small' | 'medium' | 'large' = 'large';
  @Prop() button: boolean = false;

  private sizeMap = {
    small: '25px',
    medium: '32px',
    large: '48px',
  };

  get hasImageData() {
    return this.imageUrl.startsWith('data:') || this.imageUrl.startsWith('blob:');
  }

  render() {
    return (
      <div style={{ width: this.sizeMap[this.size], height: this.sizeMap[this.size] }}>
        <ion-avatar
          class={`ion-no-margin ${this.button ? 'ion-activatable concourse-avatar__button' : ''}`}
          style={{ '--chip-color': this.color || '#2196f3', '--chip-avatar-size': this.sizeMap[this.size], 'height': this.sizeMap[this.size], 'width': this.sizeMap[this.size] }}
        >
          {this.imageUrl && !this.hasImageData && (
            <img src={this.imageUrl} style={{ color: this.color || '#ffffff', width: this.sizeMap[this.size], height: this.sizeMap[this.size] }} />
          )}
          {this.imageUrl && this.hasImageData && (
            <img class="profile-image" src={this.imageUrl} alt={this.initials} style={{ border: this.border ? `1px solid ${this.color || '#ffffff'}` : 'none' }} />
          )}
          {!this.imageUrl && this.initials && <div class="profile-logo" style={{ backgroundColor: this.color || 'var(--background-color-step-100)', border: this.border ? `1px solid ${this.color || '#ffffff'}` : 'none' }}>{this.initials}</div>}
          {!this.imageUrl && !this.initials && <ion-icon name="person-circle-outline" class="profile-icon" />}
          {this.button && <ion-ripple-effect type="unbounded"></ion-ripple-effect>}
        </ion-avatar>
      </div>
    );
  }
}
